import { render, staticRenderFns } from "./tempObjectTable.vue?vue&type=template&id=064745e7&scoped=true&"
import script from "./tempObjectTable.vue?vue&type=script&lang=js&"
export * from "./tempObjectTable.vue?vue&type=script&lang=js&"
import style0 from "./tempObjectTable.vue?vue&type=style&index=0&id=064745e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064745e7",
  null
  
)

export default component.exports